module.exports = __webpack_public_path__ + "img/linkedin.ec019f89.svg";